import { Container } from './StaticPageComponentStyles';

// Component props
type StaticPageComponentProps = {
  staticPageText: string;
};

const StaticPageComponent = ({ staticPageText }: StaticPageComponentProps) => {
  return (
    //TODO: add seo meta tags
    //assuming the data is sainitized
    <Container dangerouslySetInnerHTML={{ __html: staticPageText }}></Container>
  );
};

export default StaticPageComponent;
